import {
  VisuallyHidden as DSVisuallyHidden,
  VisuallyHiddenProps,
} from '@s-group/design-system-components/VisuallyHidden/VisuallyHidden'

export const VisuallyHidden = (props: VisuallyHiddenProps) => <DSVisuallyHidden {...props} />
